// JsFromRoutes CacheKey 8a7c9434cfa9566bec6334caf453c96b
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@js-from-routes/axios'

export default {
  create: definePathHelper('post', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:challenge_form_id/messages'),
  update: definePathHelper('patch', '/api/years/:year_id/championship_teams/:championship_team_id/challenge_forms/:challenge_form_id/messages/:id'),
}
